export const reportCorporateShipmentsTypes = {
  GET_REPORT_CORPORATE_SHIPMENTS: 'GET_REPORT_CORPORATE_SHIPMENTS',
  SET_REPORT_CORPORATE_SHIPMENTS_FILTERS: 'SET_REPORT_CORPORATE_SHIPMENTS_FILTERS',
};